import React, { useState } from 'react';
import { CheckCircle2Icon, DownloadIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { LogoMark } from '../components/LogoMark';
import { ROLE_OPTIONS } from '../data/site';
export function LeadMagnet() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // eslint-disable-next-line no-console
    console.log('resource_download_started', {
      resource: 'Starter Guide',
      source: 'lead_magnet'
    });
    setSubmitted(true);
    // eslint-disable-next-line no-console
    console.log('resource_download_completed', {
      resource: 'Starter Guide'
    });
    // eslint-disable-next-line no-console
    console.log('field_notes_signup', {
      source: 'lead_magnet'
    });
  };
  return <section className="w-full bg-sand py-20 lg:py-28" data-id="element-603">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-604">
        <div className="grid overflow-hidden rounded-2xl border border-charcoal/10 bg-cream shadow-card lg:grid-cols-2" data-id="element-605">
          <div className="relative bg-charcoal p-8 lg:p-12" data-id="element-606">
            <div className="mgs-traces absolute inset-0 opacity-30" aria-hidden data-id="element-607" />
            <div className="relative" data-id="element-608">
              <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-yellow" data-id="element-609">
                <LogoMark className="h-3.5 w-3.5" data-id="element-610" /> Free toolkit
              </p>
              <h2 className="mt-3 text-3xl font-black leading-tight text-cream sm:text-4xl" data-id="element-611">
                Download the free MGS Toolkit today.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-cream/80" data-id="element-612">
                Everything you need to start assessing and improving your mine
                geology system — in one practical download.
              </p>
              <ul className="mt-6 space-y-2.5 text-sm text-cream/85" data-id="element-613">
                {['MGS System Overview — every area of the system explained', 'MGS Checklist — a monthly system health review', 'MGS Monthly System Review — capture issues, actions and lessons', 'Yearly Scorecard Tracker — trends and recurring weaknesses over time'].map(line => <li key={line} className="flex items-start gap-2.5" data-id="element-614">
                    <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-yellow" data-id="element-615" />
                    {line}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="p-8 lg:p-12" data-id="element-616">
            {submitted ? <div className="flex h-full flex-col items-center justify-center text-center" data-id="element-617">
                <CheckCircle2Icon className="h-12 w-12 text-improvements" data-id="element-618" />
                <h3 className="mt-4 text-xl font-black text-charcoal" data-id="element-619">
                  Thanks — your guide is on its way
                </h3>
                <p className="mt-2 max-w-sm text-sm leading-relaxed text-warmgray" data-id="element-620">
                  You'll also receive practical MGS Field Notes when new
                  resources and case studies are published.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-621">
                <div className="grid gap-4 sm:grid-cols-2" data-id="element-622">
                  <div data-id="element-623">
                    <label htmlFor="lm-name" className="mb-1.5 block text-xs font-semibold text-charcoal" data-id="element-624">
                      Name
                    </label>
                    <input id="lm-name" required className="mgs-input" placeholder="Your name" data-id="element-625" />
                  </div>
                  <div data-id="element-626">
                    <label htmlFor="lm-email" className="mb-1.5 block text-xs font-semibold text-charcoal" data-id="element-627">
                      Email
                    </label>
                    <input id="lm-email" type="email" required className="mgs-input" placeholder="you@example.com" data-id="element-628" />
                  </div>
                </div>
                <div data-id="element-629">
                  <label htmlFor="lm-role" className="mb-1.5 block text-xs font-semibold text-charcoal" data-id="element-630">
                    Title
                  </label>
                  <select id="lm-role" required className="mgs-input" data-id="element-631">
                    <option value="" data-id="element-632">Select your title…</option>
                    {ROLE_OPTIONS.map(r => <option key={r} data-id="element-633">{r}</option>)}
                  </select>
                </div>
                <div data-id="element-634">
                  <label htmlFor="lm-challenge" className="mb-1.5 block text-xs font-semibold text-charcoal" data-id="element-635">
                    What is the biggest challenge in your mine geology system
                    right now? (optional)
                  </label>
                  <textarea id="lm-challenge" rows={3} className="mgs-input resize-none" placeholder="Tell us what's holding your system back…" data-id="element-636" />
                </div>
                <Button type="submit" variant="primary" className="w-full" data-id="element-637">
                  <DownloadIcon className="h-4 w-4" data-id="element-638" />
                  Send Me the Toolkit
                </Button>
                <p className="text-center text-xs leading-relaxed text-warmgray" data-id="element-639">
                  Join the Field Notes list and get practical resources, case
                  studies and framework updates. No spam.
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}